import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AnyAuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router:  Router) {

  }
  canActivate() {
    var auth = this.authService.getAuth();
    if (auth.isAuthorized()){
        return true;
    } else {
        this.router.navigate(['login']);
        return false;
    }
  }

  canActivateChild() {
    var auth = this.authService.getAuth();
    if (auth.isAuthorized()){
        return true;
    } else {
        this.router.navigate(['login']);
        return false;
    }
  }

}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/any-auth-guard.service.ts